import { render, staticRenderFns } from "./home-financial.vue?vue&type=template&id=21b27ec3&scoped=true"
var script = {}
import style0 from "./home-financial.vue?vue&type=style&index=0&id=21b27ec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b27ec3",
  null
  
)

export default component.exports